import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Grid, Tab } from 'semantic-ui-react';
import { CustomerLogin } from '../../_components/users';
import '../../_components/layout/Layout.css';

export const CustomerLoginPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const [activeIndex, setActiveIndex] = useState(0);
  const [panes, setPanes] = useState([]);

  const activate = location.pathname.includes('activate');
  const customerId = activate ? params.get('customer') : '';
  const token = activate ? params.get('auth') : '';

  useEffect(() => {
    let panes = [
      {
        menuItem: 'PASSWORD LOGIN',
        render: () => (
          <Tab.Pane attached={false}>
            <CustomerLogin
              activateCustomer={customerId}
              activateToken={token}
              location={location}
            />
          </Tab.Pane>
        )
      }
    ];

    setPanes(panes);
  }, []); // eslint-disable-line

  return (
    <div>
      <Container>
        <Grid centered padded textAlign="center" style={{ height: '90vh' }}>
          <Grid.Column style={{ maxWidth: 450 }}>
            <Tab
              menu={{ secondary: true, pointing: true, tabular: false }}
              panes={panes}
              activeIndex={activeIndex}
              onTabChange={(e, { activeIndex }) => setActiveIndex(activeIndex)}
            />
          </Grid.Column>
        </Grid>
      </Container>
    </div>
  );
};
